<div class="confirmation-dialog-wrapper">

  <!-- Close icon (top right) -->
  <button class="close-btn" mat-icon-button (click)="onConfirm(false)" aria-label="Close">
    <i class="ri-close-line"></i>
  </button>

  <!-- Icon -->
  <div class="icon-container" [ngClass]="{'danger-icon': data.dangerMode}">
    <i [class]="data.icon" class="dialog-icon"></i>
  </div>

  <!-- Title & Message -->
  <div class="content">
    <h2 class="title" *ngIf="data.title">{{ data.title }}</h2>
    <p class="message">{{ data.message }}</p>
  </div>
<!-- Reason input (only for cancel/reject actions) -->
<div class="content" *ngIf="data.showReasonInput" style="margin-top: 1.5rem;">
  <mat-form-field 
    appearance="outline" 
    class="reason-field full-width" 
    dir="auto"
    floatLabel="always">   <!-- makes label always float above -->

    <mat-label>{{ data.reasonLabel || ('CANCELLATION_REASON' | translate) }}</mat-label>
    
  <textarea
  matInput
  rows="3"
  [(ngModel)]="reason"
  [placeholder]="data.reasonPlaceholder || ('ENTER_REASON_HERE' | translate)"
  [required]="data.reasonRequired === true"
  [attr.maxlength]="data.reasonMaxLength || 500"
  cdkFocusInitial
  cdkTextareaAutosize
  #autosize="cdkTextareaAutosize"
></textarea>

    <mat-hint align="end" *ngIf="reason && reason.length > 0">
      {{ reason.length }} / {{ data.reasonMaxLength || 500 }}
    </mat-hint>

    <mat-error *ngIf="data.reasonRequired === true && !reason?.trim()">
      {{ 'REASON_IS_REQUIRED' | translate }}
    </mat-error>
  </mat-form-field>
</div>
  <!-- Buttons -->
  <div class="actions">
    <button mat-button 
            class="btn-cancel" 
            (click)="onConfirm(false)">
      {{ data.falseText }}
    </button>

    <button mat-raised-button 
            color="{{ data.dangerMode ? 'warn' : 'primary' }}"
            class="btn-confirm"
            (click)="onConfirm(true)"
            cdkFocusInitial>
      {{ data.trueText }}
    </button>
  </div>

</div>